@charset "UTF-8";
/* ===================================================
VEAMS SETTINGS
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/* ===================================================
FONTS
=================================================== */
/* ===================================================
FONTSIZES
=================================================== */
/* ===================================================
COLORS
=================================================== */
/* ===================================================
Transitions
=================================================== */
/* ===================================================
Padding / Margin
=================================================== */
/* ===================================================
Misc
=================================================== */
/* ===================================================
Buttons
=================================================== */
/* ===================================================
VEAMS SETTINGS
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/* ===================================================
FONTS
=================================================== */
/* ===================================================
FONTSIZES
=================================================== */
/* ===================================================
COLORS
=================================================== */
/* ===================================================
Transitions
=================================================== */
/* ===================================================
Padding / Margin
=================================================== */
/* ===================================================
Misc
=================================================== */
/* ===================================================
Buttons
=================================================== */
/* ===================================================
EXTENDED SETTINGS
=================================================== */
/* ===================================================
VEAMS SETTINGS
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/* ===================================================
FONTS
=================================================== */
/* ===================================================
FONTSIZES
=================================================== */
/* ===================================================
COLORS
=================================================== */
/* ===================================================
Transitions
=================================================== */
/* ===================================================
Padding / Margin
=================================================== */
/* ===================================================
Misc
=================================================== */
/* ===================================================
Buttons
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
:host([error]) {
  background-color: #ff74a2;
}

:host([alert]) {
  background-color: #ffc270;
}

:host([success]) {
  background-color: #85d0c1;
}

:host([info]) {
  background-color: #8494ff;
}

:host([dark]) {
  background-color: #0a171f;
  color: #fff;
}

:host([accent]) {
  background-color: #eaf7ff;
}

:host([info]) {
  display: inline-block;
  margin-right: 2em;
}

/* top, bottom and y paddings */
:host([p-0]), :host([pt-0]), :host([py-0]) {
  padding-top: 0;
}

:host([p-0]), :host([pb-0]), :host([py-0]) {
  padding-bottom: 0;
}

:host([p-1]), :host([pt-1]), :host([py-1]), ::slotted([p-1]), ::slotted([pt-1]), ::slotted([py-1]) {
  padding-top: 12px;
}

:host([p-1]), :host([pb-1]), :host([py-1]), ::slotted([p-1]), ::slotted([pb-1]), ::slotted([py-1]) {
  padding-bottom: 12px;
}

:host([p-2]), :host([pt-2]), :host([py-2]), ::slotted([p-2]), ::slotted([pt-2]), ::slotted([py-2]) {
  padding-top: 24px;
}

:host([p-2]), :host([pb-2]), :host([py-2]), ::slotted([p-2]), ::slotted([pb-2]), ::slotted([py-2]) {
  padding-bottom: 24px;
}

:host([p-3]), :host([pt-3]), :host([py-3]), ::slotted([p-3]), ::slotted([pt-3]), ::slotted([py-3]) {
  padding-top: 32px;
}

:host([p-3]), :host([pb-3]), :host([py-3]), ::slotted([p-3]), ::slotted([pb-3]), ::slotted([py-3]) {
  padding-bottom: 32px;
}

:host([p-4]), :host([pt-4]), :host([py-4]), ::slotted([p-4]), ::slotted([pt-4]), ::slotted([py-3]) {
  padding-top: 40px;
}

:host([p-4]), :host([pb-4]), :host([py-4]), ::slotted([p-4]), ::slotted([pb-4]), ::slotted([py-4]) {
  padding-bottom: 40px;
}

:host([p-5]), :host([pt-5]), :host([py-5]) {
  padding-top: 80px;
}

:host([p-5]), :host([pb-5]), :host([py-5]) {
  padding-bottom: 80px;
}

/* left, right and x paddings */
:host([p-0]), :host([pl-0]), :host([px-0]) {
  padding-left: 0;
}

:host([p-0]), :host([pr-0]), :host([px-0]) {
  padding-right: 0;
}

:host([p-1]), :host([pl-1]), :host([px-1]) {
  padding-left: 12px;
}

:host([p-1]), :host([pr-1]), :host([px-1]) {
  padding-right: 12px;
}

:host([p-2]), :host([pl-2]), :host([px-2]) {
  padding-left: 24px;
}

:host([p-2]), :host([pr-2]), :host([px-2]) {
  padding-right: 24px;
}

:host([p-3]), :host([pl-3]), :host([px-3]) {
  padding-left: 32px;
}

:host([p-3]), :host([pr-3]), :host([px-2]) {
  padding-right: 32px;
}

:host([p-4]), :host([pl-4]), :host([px-4]) {
  padding-left: 40px;
}

:host([p-4]), :host([pr-4]), :host([px-4]) {
  padding-right: 40px;
}

:host([p-5]), :host([pl-5]), :host([px-5]) {
  padding-left: 80px;
}

:host([p-5]), :host([pr-5]), :host([px-5]) {
  padding-right: 80px;
}

/* ToDo: Own Mixin for layout */
:host([layout-stretch]), ::slotted([layout-stretch]) {
  display: flex;
  flex-direction: row;
  align-content: space-between;
}

/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/* ===================================================
Reset Button
=================================================== */
/*
Extend
----------------------- */
/* ===================================================
VEAMS SETTINGS
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/* ===================================================
FONTS
=================================================== */
/* ===================================================
FONTSIZES
=================================================== */
/* ===================================================
COLORS
=================================================== */
/* ===================================================
Transitions
=================================================== */
/* ===================================================
Padding / Margin
=================================================== */
/* ===================================================
Misc
=================================================== */
/* ===================================================
Buttons
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/* ===================================================
VEAMS SETTINGS
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/* ===================================================
FONTS
=================================================== */
/* ===================================================
FONTSIZES
=================================================== */
/* ===================================================
COLORS
=================================================== */
/* ===================================================
Transitions
=================================================== */
/* ===================================================
Padding / Margin
=================================================== */
/* ===================================================
Misc
=================================================== */
/* ===================================================
Buttons
=================================================== */
/* ---------------------------------------------------
A11y-focus
--------------------------------------------------- */
/* ===================================================
Reset Button
=================================================== */
/*
Extend
----------------------- */
/* ===================================================
Pseudo Element
=================================================== */
/*
Extend
----------------------- */
/* ===================================================
Button and Link Styles
=================================================== */
/* ===================================================
Hiding Elements
=================================================== */
/* ---------------------------------------------------
ir
--------------------------------------------------- */
/* ---------------------------------------------------
Hidden
--------------------------------------------------- */
/* ---------------------------------------------------
Visually hidden
--------------------------------------------------- */
/* ---------------------------------------------------
Visibility hidden
--------------------------------------------------- */
/* ---------------------------------------------------
Hide text
--------------------------------------------------- */
/* ===================================================
Pseudo Element
=================================================== */
/*
Extend
----------------------- */
/* ===================================================
CENTERING MIXIN
=================================================== */
/* ===================================================
VEAMS SETTINGS
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/* ===================================================
FONTS
=================================================== */
/* ===================================================
FONTSIZES
=================================================== */
/* ===================================================
COLORS
=================================================== */
/* ===================================================
Transitions
=================================================== */
/* ===================================================
Padding / Margin
=================================================== */
/* ===================================================
Misc
=================================================== */
/* ===================================================
Buttons
=================================================== */
/* ===================================================
VEAMS SETTINGS
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/* ===================================================
FONTS
=================================================== */
/* ===================================================
FONTSIZES
=================================================== */
/* ===================================================
COLORS
=================================================== */
/* ===================================================
Transitions
=================================================== */
/* ===================================================
Padding / Margin
=================================================== */
/* ===================================================
Misc
=================================================== */
/* ===================================================
Buttons
=================================================== */
/* ===================================================
EXTENDED SETTINGS
=================================================== */
/* ===================================================
VEAMS SETTINGS
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/* ===================================================
FONTS
=================================================== */
/* ===================================================
FONTSIZES
=================================================== */
/* ===================================================
COLORS
=================================================== */
/* ===================================================
Transitions
=================================================== */
/* ===================================================
Padding / Margin
=================================================== */
/* ===================================================
Misc
=================================================== */
/* ===================================================
Buttons
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/*

  SIZE VARIATIONS

  default, large, small

  die Buttons kommen in drei verschiedene Größen vor.
  Sie unterscheiden sich durch
   - die Höhe
   - seitliches Padding
   - border-radius
   - margins der Kind-Elemente
   - Icon Größe
   - Schrift size (und weight bei small)

*/
/* Size variations */
:host {
  border-radius: 4px;
  height: 28px;
  font-size: var(--fontsize-button-medium, 1.2rem);
  line-height: calc(var(--fontsize-button-medium, 1.2rem) + .4rem);
  font-weight: 400;
  font-family: "PT Sans Narrow", "Arial Narrow", Helvetica, Arial, sans-serif;
  padding: 0 4px;
}
@media only screen and (min-width: 414px) {
  :host {
    font-size: calc(var(--fontsize-button-medium, 1.2rem) + calc(.1rem * 1));
    line-height: calc(calc(var(--fontsize-button-medium, 1.2rem) + .4rem) + calc(.1rem * 1));
  }
}
@media only screen and (min-width: 768px) {
  :host {
    font-size: calc(var(--fontsize-button-medium, 1.2rem) + calc(.2rem * 1));
    line-height: calc(calc(var(--fontsize-button-medium, 1.2rem) + .4rem) + calc(.2rem * 1));
  }
}
@media only screen and (min-width: 960px) {
  :host {
    font-size: calc(var(--fontsize-button-medium, 1.2rem) + calc(.3rem * 1));
    line-height: calc(calc(var(--fontsize-button-medium, 1.2rem) + .4rem) + calc(.3rem * 1));
  }
}
@media only screen and (min-width: 1120px) {
  :host {
    font-size: calc(var(--fontsize-button-medium, 1.2rem) + calc(.4rem * 1));
    line-height: calc(calc(var(--fontsize-button-medium, 1.2rem) + .4rem) + calc(.4rem * 1));
  }
}
:host ::slotted(c-icon) {
  width: 22px;
  height: 22px;
}
:host ::slotted(span:first-child) {
  margin-left: 6px;
  margin-right: 4px;
}
:host ::slotted(span:last-child) {
  margin-right: 6px;
  margin-left: 0;
}
:host ::slotted(span:only-child) {
  margin-left: 6px;
  margin-right: 6px;
}
:host ::slotted(c-icon:nth-child(2)) {
  margin-right: 6px;
}
:host ::slotted(c-icon:first-child) {
  margin-left: 4px;
  margin-right: 4px;
}
:host ::slotted(c-icon:only-child) {
  margin: 0;
}

:host([large]) {
  border-radius: 6px;
  height: var(--button-large-height, 48px);
  font-size: var(--fontsize-button-large, 1.5rem);
  line-height: calc(var(--fontsize-button-large, 1.5rem) + .4rem);
  font-family: "PT Sans", "Arial Narrow", Helvetica, Arial, sans-serif;
  padding: 0 9px;
}
@media only screen and (min-width: 414px) {
  :host([large]) {
    font-size: calc(var(--fontsize-button-large, 1.5rem) + calc(.1rem * 1));
    line-height: calc(calc(var(--fontsize-button-large, 1.5rem) + .4rem) + calc(.1rem * 1));
  }
}
@media only screen and (min-width: 768px) {
  :host([large]) {
    font-size: calc(var(--fontsize-button-large, 1.5rem) + calc(.2rem * 1));
    line-height: calc(calc(var(--fontsize-button-large, 1.5rem) + .4rem) + calc(.2rem * 1));
  }
}
@media only screen and (min-width: 960px) {
  :host([large]) {
    font-size: calc(var(--fontsize-button-large, 1.5rem) + calc(.3rem * 1));
    line-height: calc(calc(var(--fontsize-button-large, 1.5rem) + .4rem) + calc(.3rem * 1));
  }
}
@media only screen and (min-width: 1120px) {
  :host([large]) {
    font-size: calc(var(--fontsize-button-large, 1.5rem) + calc(.4rem * 1));
    line-height: calc(calc(var(--fontsize-button-large, 1.5rem) + .4rem) + calc(.4rem * 1));
  }
}
:host([large]) ::slotted(c-icon) {
  width: 28px;
  height: 28px;
}
:host([large]) ::slotted(span) {
  margin-inline-end: 8px;
  margin-inline-start: 8px;
}
:host([large]) ::slotted(span:first-child) {
  margin-left: 12px;
}
:host([large]) ::slotted(c-icon:nth-child(2)) {
  margin-right: 8px;
}
:host([large]) ::slotted(c-icon:first-child) {
  margin-left: 8px;
  margin-right: 0;
}
:host([large]) ::slotted(c-icon:only-child) {
  margin: 0;
}

:host([large][rounded]) {
  border-radius: 24px;
}

:host([rounded]) {
  border-radius: 14px;
}

:host([small][rounded]) {
  border-radius: 10px;
}

:host([small]) {
  border-radius: 2px;
  height: 20px;
  font-size: var(--fontsize-button-small, 1rem);
  line-height: calc(var(--fontsize-button-small, 1rem) + .4rem);
  font-family: "PT Sans", "Arial Narrow", Helvetica, Arial, sans-serif;
  font-weight: bold;
  padding: 0 1px;
}
@media only screen and (min-width: 414px) {
  :host([small]) {
    font-size: calc(var(--fontsize-button-small, 1rem) + calc(.1rem * 1));
    line-height: calc(calc(var(--fontsize-button-small, 1rem) + .4rem) + calc(.1rem * 1));
  }
}
@media only screen and (min-width: 768px) {
  :host([small]) {
    font-size: calc(var(--fontsize-button-small, 1rem) + calc(.2rem * 1));
    line-height: calc(calc(var(--fontsize-button-small, 1rem) + .4rem) + calc(.2rem * 1));
  }
}
@media only screen and (min-width: 960px) {
  :host([small]) {
    font-size: calc(var(--fontsize-button-small, 1rem) + calc(.3rem * 1));
    line-height: calc(calc(var(--fontsize-button-small, 1rem) + .4rem) + calc(.3rem * 1));
  }
}
@media only screen and (min-width: 1120px) {
  :host([small]) {
    font-size: calc(var(--fontsize-button-small, 1rem) + calc(.4rem * 1));
    line-height: calc(calc(var(--fontsize-button-small, 1rem) + .4rem) + calc(.4rem * 1));
  }
}
:host([small]) ::slotted(c-icon) {
  width: 16px;
  height: 16px;
}
:host([small]) ::slotted(span) {
  margin: 0 4px 0 2px;
}
:host([small]) ::slotted(span:first-child) {
  margin-left: 5px;
}
:host([small]) ::slotted(c-icon:nth-child(2)) {
  margin-right: 4px;
}
:host([small]) ::slotted(c-icon:first-child) {
  margin-left: 3px;
  margin-right: 0;
}
:host([small]) ::slotted(c-icon:only-child) {
  margin: 0;
}

:host(:last-child) {
  margin-right: 0;
}

:host(.auto-height) {
  height: auto;
}
:host(.auto-height) ::slotted(span) {
  white-space: normal;
  padding-top: 10px;
  padding-bottom: 10px;
}
:host(.auto-height) ::slotted(c-icon) {
  align-self: baseline;
  padding-top: 6px;
}

/* modifiers: block, disabled */
:host {
  font-family: "PT Sans", "Arial Narrow", Helvetica, Arial, sans-serif;
  cursor: pointer;
  outline: none;
  vertical-align: bottom;
  border: 1px solid transparent;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  transition-property: background, border-color, transform, box-shadow;
  transition-duration: 300ms;
  transition-timing-function: ease-in-out;
  margin-right: 16px;
  white-space: nowrap;
}
:host ::slotted(span) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

:host([block]) {
  display: flex;
  width: 100%;
  justify-content: start;
}

:host([centered-content]) {
  justify-content: center;
}

:host([disabled]) {
  box-shadow: none !important;
  cursor: not-allowed;
  transition: unset;
  pointer-events: none;
}

:host([attached=left]) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: none !important;
}

:host([attached=right]) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  margin-right: 0;
}

:host([attached=horizontal]) {
  border-radius: 0;
  border-left: none !important;
  margin-right: 0;
}

:host {
  background-color: transparent;
  border-color: #183447;
  color: #183447;
}

:host([disabled]) {
  color: rgba(24, 52, 71, 0.72);
}

:host(:hover), :host(.hover) {
  background: rgba(55, 121, 163, 0.24);
}

:host(:focus),
:host([active]) {
  background: #3779a3;
  color: #eaf7ff;
  border: 1px solid #3779a3;
}

:host([alternate]) {
  border-color: #3779a3;
  background: rgba(55, 121, 163, 0.04);
}

:host([alternate][disabled]) {
  background-color: rgba(55, 121, 163, 0.24);
  color: rgba(24, 52, 71, 0.72);
  border: none;
}

:host([alternate]:hover) {
  background: rgba(55, 121, 163, 0.24);
}

:host([alternate]:focus) {
  box-shadow: 0 0 4px 0 #57beff;
  border-color: #57beff;
  color: #0a171f;
}

:host([alternate][active]), :host([alternate]:active) {
  background: #fff;
  color: #0a171f;
}

:host([alert]) {
  background-color: transparent;
  border-color: #ffc270 !important;
}

:host([alert]:hover) {
  background-color: rgba(255, 194, 112, 0.24);
}

:host([alert][active]), :host([alert]:active), :host([alert]:focus) {
  background: #ffc270 !important;
  color: #0a171f;
}

:host([error]) {
  background-color: transparent;
  border-color: #a7003b !important;
  color: #a7003b;
}

:host([error]:hover) {
  background-color: rgba(255, 116, 162, 0.24);
}

:host([error][active]), :host([error]:active), :host([error]:focus) {
  background: #a7003b !important;
  color: #fff;
}

:host([active][readonly]) {
  border-color: #0a171f;
  background: #0a171f;
  color: #fff;
}

:host([primary]) {
  background-color: #406795;
  color: #d0ecff;
  border: 1px solid transparent;
}

:host([primary][disabled]) {
  opacity: 0.72;
}

:host([primary]:hover), :host([primary].hover), :host([primary]:focus) {
  background-color: #294876;
}

:host([primary]:focus),
:host([primary][active]) {
  background: #57beff;
  color: #fff;
}

:host([primary][alternate]) {
  background: #fff;
  box-shadow: 0 4px 8px 0 rgba(55, 121, 163, 0.24);
  color: #0a171f;
}

:host([primary][alternate]:hover) {
  background: #fff;
  border: 1px solid transparent;
}

:host([primary][alternate][active]), :host([primary][alternate]:active) {
  background: #57beff;
}

:host([primary][alert]) {
  background-color: #ffc270 !important;
  color: #0a171f !important;
}

:host([primary][error]) {
  background-color: #a7003b !important;
  color: #fff !important;
}

:host([primary][error][active]), :host([primary][error]:active), :host([primary][error]:focus) {
  background: #ff74a2 !important;
  border-color: #ff74a2 !important;
  color: #fff;
}

:host([minimal]) {
  background: none;
  border: 1px solid transparent;
}

:host([minimal][disabled]) {
  opacity: 0.72;
}

:host([minimal]:hover), :host([minimal].hover) {
  color: #57beff;
}

:host([minimal]:focus) {
  border: 1px solid transparent;
  box-shadow: 0 0 4px 0 #57beff;
  color: #57beff;
}

:host([minimal][alternate]) {
  color: #57beff;
}

:host([minimal][alternate]:hover) {
  border: 1px solid transparent;
  color: #d0ecff;
}

:host([minimal][alternate][active]), :host([minimal][alternate]:active) {
  border: 1px solid transparent;
  color: #d0ecff;
}

:host([minimal][alert]) {
  background-color: transparent !important;
  border-color: transparent !important;
  color: #ffc270 !important;
}

:host([minimal][error]) {
  background-color: transparent !important;
  border-color: transparent !important;
  color: #a7003b !important;
}

:host([minimal][error][active]), :host([minimal][error]:active), :host([minimal][error]:focus) {
  color: #ff74a2 !important;
  box-shadow: 0 0 4px 0 #ff74a2;
}

:host([minimal][error]:hover) {
  color: #ff74a2 !important;
}